import {Component, Input, OnInit} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {
  RetailerBankingDetailsDialogComponent
} from "@features/leads/retailers/retailer-view/retailer-billing-details/retailer-banking-details-dialog/retailer-banking-details-dialog.component";
import {ConsoleContextService} from "@security/console-context.service";
import {AddressService} from "@shared-services/address/address.service";
import {DateUtilsService} from "@shared-services/dateUtils.service";
import {UtilsService} from "@shared-services/utils.service";
import {LoadingService} from "@ui-kit/framework/util/service/loading.service";
import {Observable} from "rxjs";
import {RetailerBankingDetails, RetailerBillingDetails} from "../../retailers.model";
import {RetailerViewService} from "../retailer-view.service";

@Component({
  selector: 'app-retailer-billing-details',
  templateUrl: './retailer-billing-details.component.html',
})
export class RetailerBillingDetailsComponent implements OnInit {
  @Input() id!: string;
  billingDetails!: RetailerBillingDetails;
  bankingDetails: RetailerBankingDetails[] = [];

  editingBillingDetails = false;
  editingBankingDetails = false;

  loading$!: Observable<boolean>;

  place: any = null;
  geometry: any = null;

  confirmRemove = false;

  constructor(public context: ConsoleContextService,
              private retailerService: RetailerViewService,
              public utils: UtilsService,
              public loader: LoadingService,
              public mapsAddressUtil: AddressService,
              public dateUtils: DateUtilsService,
              private matDialog: MatDialog) {
  }

  ngOnInit() {
    this.loadBillingDetails();
    this.loadBankingDetails();

    this.loading$ = this.loader.loading$;
  }

  loadBillingDetails() {
    this.retailerService.getRetailerBillingDetails(this.id).subscribe({
      next: value => {
        this.billingDetails = value;
        if (!value) this.billingDetails = new RetailerBillingDetails();
        this.billingDetails.sameAddress = true;
        },
      error: err => { console.log(err); }
    })
  }

  loadBankingDetails() {
    this.retailerService.getRetailerBankingDetails(this.id).subscribe({
      next: value => {
        this.bankingDetails = value;
        if (!value)
          this.bankingDetails = [];
      },
      error: err => { console.log(err); }
    })
  }

  updateBillingDetails() {
    if (!this.billingDetails.sameAddress) {
      const addressData = this.mapsAddressUtil.parseJsonAddressData(this.geometry, this.place);
      this.billingDetails.address = addressData.address;
      this.billingDetails.addressPlace = addressData.addressPlace;
    }
    this.retailerService.updateRetailerBillingDetails(this.id, this.billingDetails).subscribe({
      next: value => {
        this.billingDetails = value;
        this.editingBillingDetails = false;
      }, error: err => { console.log(err); }
    })
  }

  updateBankingDetails() {
    this.editBankingDetails(true);
    this.matDialog.open(RetailerBankingDetailsDialogComponent, {
      panelClass: 'dialog-large',
      data: {
        retailerId: this.id
      }
    }).afterClosed().subscribe(() => {
      this.editBankingDetails(false);
      this.loadBankingDetails();
    })
  }

  removeBankingDetails() {
    this.retailerService.removeRetailerBankingDetails(this.id, this.bankingDetails[0].uuid!)
      .subscribe({
        next: value => {
          this.confirmRemove = false;
          console.log('removed banking details for retailer: ' + this.id);
          this.loadBankingDetails();
        },
        error: err => { console.log(err); }
      });
  }

  editBillingDetails(edit: boolean) {
    this.editingBillingDetails = edit;
    if (!edit) this.loadBillingDetails();
  }

  editBankingDetails(edit: boolean) {
    this.editingBankingDetails = true;
    if (!edit) this.loadBankingDetails();
  }

  onAddressAutocompleteSelected(event: any): void {
    this.billingDetails.sameAddress = false;
    this.place = event;
  }

  onAddressLocationSelected(event: any): void {
    this.billingDetails.sameAddress = false;
    this.geometry = event;
  }
}
